<template>
	<div
		class="vertical-menu"
	>
		<simplebar class="h-100" ref="currentMenu" id="my-element">
			<div id="sidebar-menu">
				<ul class="metismenu list-unstyled" id="side-menu">
					<template
						v-for="item in menuItems"
					>
						<li
							v-if="item.isTitle"
							class="menu-title"
							:key="item.id"
						>
							{{ $t(item.label) }}
						</li>
						<li
							v-if="!item.isTitle && !item.isLayout"
							:key="item.id"
						>
							<router-link
								v-if="hasItems(item)"
								:to="item.link || '#'"
								:target="item.externalLink ? '_blank' : null"
								:rel="item.externalLink ? 'noopener noreferrer' : null"
								:class="{
									'is-parent': true,
									'has-arrow': !item.badge,
									'has-dropdown': item.badge,
								}"
							>
								<i
									v-if="item.icon"
									:class="[
										item.icon,
										'mr-1',
									]"
								></i>
								<span>
									{{ $t(item.label) }}
								</span>
								<span
									v-if="item.badge"
									:class="[
										'badge',
										'badge-pill',
										'float-right',
										`badge-${item.badge.variant}`,
									]"
								>
									{{ $t(item.badge.text) }}
								</span>
							</router-link>
							<router-link
								v-if="!hasItems(item)"
								:to="item.link"
								:target="item.externalLink ? '_blank' : null"
								:rel="item.externalLink ? 'noopener noreferrer' : null"
								class="side-nav-link-ref"
							>
								<i
									v-if="item.icon"
									:class="[
										item.icon,
										'mr-1',
									]"
								></i>
								<span>
									{{ $t(item.label) }}
								</span>
								<span
									v-if="item.badge"
									:class="[
										'badge',
										'badge-pill',
										'float-right',
										`badge-${item.badge.variant}`,
									]"
								>
									{{ $t(item.badge.text) }}
								</span>
							</router-link>
							<ul
								v-if="hasItems(item)"
								class="sub-menu"
								aria-expanded="false"
							>
								<li
									v-for="(subitem, index) of item.subItems"
									:key="index"
								>
									<router-link
										v-if="!hasItems(subitem)"
										:to="subitem.link"
										:target="subitem.externalLink ? '_blank' : null"
										:rel="subitem.externalLink ? 'noopener noreferrer' : null"
										class="side-nav-link-ref text-nowrap"
									>
										<i class="mdi mdi-record-circle font-size-8 submenu-dot"></i> {{ $t(subitem.label) }}
									</router-link>
									<a
										v-if="hasItems(subitem)"
										class="side-nav-link-a-ref has-arrow"
										href="javascript:void(0);"
									>
										{{ subitem.label }}
									</a>
									<ul
										v-if="hasItems(subitem)"
										class="sub-menu mm-collapse"
										aria-expanded="false"
									>
										<li 
											v-for="(subSubitem, index) of subitem.subItems" 
											:key="index"
										>
											<router-link
												:to="subSubitem.link"
												:target="subSubitem.externalLink ? '_blank' : null"
												:rel="subSubitem.externalLink ? 'noopener noreferrer' : null"
												class="side-nav-link-ref"
											>
												{{ $t(subSubitem.label) }}
											</router-link>
										</li>
									</ul>
								</li>
							</ul>
						</li>
					</template>
				</ul>
			</div>
		</simplebar>
	</div>
</template>
<script>
import simplebar from "simplebar-vue";
import MetisMenu from "metismenujs/dist/metismenujs";
import { sessionHelper } from '@/utils';
import { admins, ihextars } from "@/components/menu";

export default {
	components: { simplebar },
	props: {
		isCondensed: {
			type: Boolean,
			default: false,
		},
		type: {
			type: String,
			required: true,
		},
		width: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			menuItems: sessionHelper.getUserType() == "api" ? admins : ihextars,
		};
	},
	mounted() {
		this.initMetisMenu();
		this.setActiveMenu();
	},
	methods: {
		hasItems(item) {
			return Array.isArray(item.subItems) && item.subItems.length > 0;
		},
		initMetisMenu() {
			this.menuRef = new MetisMenu("#side-menu");
		},
		setActiveMenu() {
			const links = document.querySelectorAll(".side-nav-link-ref");

			links.forEach((link) => {
				link.classList.remove("active");
			});

			const matchingMenuItem = Array.from(links).find(
				(link) => window.location.pathname === link.pathname
			);

			if (!matchingMenuItem) return;

			matchingMenuItem.classList.add("active");

			let parent = matchingMenuItem.parentElement;

			while (parent && parent.id !== "side-menu") {
				if (parent.tagName === "LI") {
					parent.classList.add("mm-active");

					const arrow = parent.querySelector(".has-arrow, .has-dropdown, .is-parent");
					if (arrow) arrow.classList.add("mm-active");
				}

				if (parent.tagName === "UL") {
					parent.classList.add("mm-show");
				}

				parent = parent.parentElement;
			}
		},
		onRoutechange() {
			this.$nextTick(() => {
				this.setActiveMenu();

				setTimeout(() => {
					const currentPosition = document.querySelector(".mm-active")?.offsetTop;

					if (currentPosition > 400 && this.$refs.currentMenu) {
						this.$refs.currentMenu.SimpleBar.getScrollElement().scrollTop =
							currentPosition + 200;
					}
				}, 300);
			});
		},
	},
	watch: {
		$route: {
			handler: "onRoutechange",
			immediate: true,
			deep: true,
		},
		type: {
			immediate: true,
			handler(newVal, oldVal) {
				if (newVal !== oldVal) {
					switch (newVal) {
						case "dark":
							document.body.setAttribute("data-sidebar", "dark");
							document.body.removeAttribute("data-topbar");
							document.body.removeAttribute("data-sidebar-size");
							break;
						case "light":
							document.body.setAttribute("data-topbar", "dark");
							document.body.removeAttribute("data-sidebar");
							document.body.removeAttribute("data-sidebar-size");
							document.body.classList.remove("vertical-collpsed");
							break;
						case "compact":
							document.body.setAttribute("data-sidebar-size", "small");
							document.body.setAttribute("data-sidebar", "dark");
							document.body.classList.remove("vertical-collpsed");
							document.body.removeAttribute("data-topbar", "dark");
							break;
						case "icon":
							document.body.setAttribute("data-keep-enlarged", "true");
							document.body.classList.add("vertical-collpsed");
							document.body.setAttribute("data-sidebar", "dark");
							document.body.removeAttribute("data-topbar", "dark");
							break;
						case "colored":
							document.body.setAttribute("data-sidebar", "colored");
							document.body.removeAttribute("data-keep-enlarged");
							document.body.classList.remove("vertical-collpsed");
							document.body.removeAttribute("data-sidebar-size");
							break;
						default:
							document.body.setAttribute("data-sidebar", "dark");
							break;
					}
				}
			},
		},
		width: {
			immediate: true,
			handler(newVal, oldVal) {
				if (newVal !== oldVal) {
					switch (newVal) {
						case "boxed":
							document.body.setAttribute("data-layout-size", "boxed");
							break;
						case "fluid":
							document.body.setAttribute("data-layout-mode", "fluid");
							document.body.removeAttribute("data-layout-size");
							break;
						default:
							document.body.setAttribute("data-layout-mode", "fluid");
							break;
					}
				}
			},
		},
	},
};
</script>
<style>

.submenu-dot {
	margin-right: 2px !important;
	width: auto !important;
	min-width: auto !important;
}

#sidebar-menu ul li ul.sub-menu li > a {
    padding-left: 44px !important;
}

</style>